"use strict";
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyObjectUnserializer = void 0;
/**
 * Utility for unserializing survey objects that come from serialized survey objects
 * with the structure: { _attributes: {...}, _customAttributes: {...}, ...otherProps }
 */
class SurveyObjectUnserializer {
    /**
     * Flattens serialized data by concatenating _attributes and _customAttributes
     * Preserves composed objects (starting with _) at top level for constructors
     * @param backendData - Data from backend with _attributes and _customAttributes at top level
     * @returns Flattened params ready for the object constructor
     */
    static flattenSerializedData(backendData) {
        // Extract the nested structures
        const attributes = backendData._attributes || {};
        const customAttributes = backendData._customAttributes || {};
        // Remove the nested _attributes and _customAttributes from the top level
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { _attributes: _, _customAttributes: __ } = backendData, otherProps = __rest(backendData, ["_attributes", "_customAttributes"]);
        // Simply concatenate everything - let the constructors handle composed objects
        const flattenedParams = Object.assign(Object.assign(Object.assign({}, otherProps), attributes), customAttributes);
        return flattenedParams;
    }
}
exports.SurveyObjectUnserializer = SurveyObjectUnserializer;
//# sourceMappingURL=SurveyObjectUnserializer.js.map